var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFooterflagbg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 270,
    viewBox: "0 0 1440 270",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48 78.1602H0V270.36H48V78.1602Z",
    fill: "#CD2027"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M96 78.1602H48V270.36H96V78.1602Z",
    fill: "#F3F4F5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M144 78.1602H96V270.36H144V78.1602Z",
    fill: "#CD2027"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M192 78.1602H144V270.36H192V78.1602Z",
    fill: "#F3F4F5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M240 78.1602H192V270.36H240V78.1602Z",
    fill: "#CD2027"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M287.99 78.1602H239.99V270.36H287.99V78.1602Z",
    fill: "#F3F4F5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M335.99 78.1602H287.99V270.36H335.99V78.1602Z",
    fill: "#CD2027"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M383.99 78.1602H335.99V270.36H383.99V78.1602Z",
    fill: "#F3F4F5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M431.99 78.1602H383.99V270.36H431.99V78.1602Z",
    fill: "#CD2027"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M479.99 78.1602H431.99V270.36H479.99V78.1602Z",
    fill: "#F3F4F5"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M527.99 78.1602H479.99V270.36H527.99V78.1602Z",
    fill: "#CD2027"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M575.99 78.1602H527.99V270.36H575.99V78.1602Z",
    fill: "#F3F4F5"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M623.99 78.1602H575.99V270.36H623.99V78.1602Z",
    fill: "#CD2027"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M671.98 78.1602H623.98V270.36H671.98V78.1602Z",
    fill: "#F3F4F5"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M719.98 78.1602H671.98V270.36H719.98V78.1602Z",
    fill: "#CD2027"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M767.98 78.1602H719.98V270.36H767.98V78.1602Z",
    fill: "#F3F4F5"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M815.98 78.1602H767.98V270.36H815.98V78.1602Z",
    fill: "#CD2027"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M863.98 78.1602H815.98V270.36H863.98V78.1602Z",
    fill: "#F3F4F5"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M911.98 78.1602H863.98V270.36H911.98V78.1602Z",
    fill: "#CD2027"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M959.98 78.1602H911.98V270.36H959.98V78.1602Z",
    fill: "#F3F4F5"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M1007.98 78.1602H959.98V270.36H1007.98V78.1602Z",
    fill: "#CD2027"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M1055.97 78.1602H1007.97V270.36H1055.97V78.1602Z",
    fill: "#F3F4F5"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M1103.97 78.1602H1055.97V270.36H1103.97V78.1602Z",
    fill: "#CD2027"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M1151.97 78.1602H1103.97V270.36H1151.97V78.1602Z",
    fill: "#F3F4F5"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M1199.97 78.1602H1151.97V270.36H1199.97V78.1602Z",
    fill: "#CD2027"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M1247.97 78.1602H1199.97V270.36H1247.97V78.1602Z",
    fill: "#F3F4F5"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M1295.97 78.1602H1247.97V270.36H1295.97V78.1602Z",
    fill: "#CD2027"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M1343.97 78.1602H1295.97V270.36H1343.97V78.1602Z",
    fill: "#F3F4F5"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M1391.97 78.1602H1343.97V270.36H1391.97V78.1602Z",
    fill: "#CD2027"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M1439.97 78.1602H1391.97V270.36H1439.97V78.1602Z",
    fill: "#F3F4F5"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M1440 0H0V95.45H1440V0Z",
    fill: "#265CA9"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M55.88 21.5L62.39 41.53H83.45L66.41 53.92L72.92 73.95L55.88 61.57L38.84 73.95L45.35 53.92L28.3 41.53H49.37L55.88 21.5Z",
    fill: "#F3F4F5"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M134.01 21.5L140.52 41.53H161.58L144.54 53.92L151.05 73.95L134.01 61.57L116.96 73.95L123.47 53.92L106.43 41.53H127.5L134.01 21.5Z",
    fill: "#F3F4F5"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M212.13 21.5L218.64 41.53H239.71L222.67 53.92L229.18 73.95L212.13 61.57L195.09 73.95L201.6 53.92L184.56 41.53H205.63L212.13 21.5Z",
    fill: "#F3F4F5"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M290.26 21.5L296.77 41.53H317.84L300.79 53.92L307.3 73.95L290.26 61.57L273.22 73.95L279.73 53.92L262.69 41.53H283.75L290.26 21.5Z",
    fill: "#F3F4F5"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M368.39 21.5L374.9 41.53H395.96L378.92 53.92L385.43 73.95L368.39 61.57L351.35 73.95L357.86 53.92L340.82 41.53H361.88L368.39 21.5Z",
    fill: "#F3F4F5"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M446.52 21.5L453.03 41.53H474.09L457.05 53.92L463.56 73.95L446.52 61.57L429.48 73.95L435.98 53.92L418.94 41.53H440.01L446.52 21.5Z",
    fill: "#F3F4F5"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M524.65 21.5L531.15 41.53H552.22L535.18 53.92L541.69 73.95L524.65 61.57L507.6 73.95L514.11 53.92L497.07 41.53H518.14L524.65 21.5Z",
    fill: "#F3F4F5"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M602.77 21.5L609.28 41.53H630.35L613.31 53.92L619.81 73.95L602.77 61.57L585.73 73.95L592.24 53.92L575.2 41.53H596.26L602.77 21.5Z",
    fill: "#F3F4F5"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M680.9 21.5L687.41 41.53H708.47L691.43 53.92L697.94 73.95L680.9 61.57L663.86 73.95L670.37 53.92L653.33 41.53H674.39L680.9 21.5Z",
    fill: "#F3F4F5"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M759.03 21.5L765.54 41.53H786.6L769.56 53.92L776.07 73.95L759.03 61.57L741.99 73.95L748.5 53.92L731.45 41.53H752.52L759.03 21.5Z",
    fill: "#F3F4F5"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M837.16 21.5L843.67 41.53H864.73L847.69 53.92L854.2 73.95L837.16 61.57L820.11 73.95L826.62 53.92L809.58 41.53H830.65L837.16 21.5Z",
    fill: "#F3F4F5"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M915.28 21.5L921.79 41.53H942.86L925.82 53.92L932.33 73.95L915.28 61.57L898.24 73.95L904.75 53.92L887.71 41.53H908.77L915.28 21.5Z",
    fill: "#F3F4F5"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M993.41 21.5L999.92 41.53H1020.99L1003.94 53.92L1010.45 73.95L993.41 61.57L976.37 73.95L982.88 53.92L965.84 41.53H986.9L993.41 21.5Z",
    fill: "#F3F4F5"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M1071.54 21.5L1078.05 41.53H1099.11L1082.07 53.92L1088.58 73.95L1071.54 61.57L1054.5 73.95L1061.01 53.92L1043.96 41.53H1065.03L1071.54 21.5Z",
    fill: "#F3F4F5"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M1149.67 21.5L1156.18 41.53H1177.24L1160.2 53.92L1166.71 73.95L1149.67 61.57L1132.62 73.95L1139.13 53.92L1122.09 41.53H1143.16L1149.67 21.5Z",
    fill: "#F3F4F5"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M1227.79 21.5L1234.3 41.53H1255.37L1238.33 53.92L1244.84 73.95L1227.79 61.57L1210.75 73.95L1217.26 53.92L1200.22 41.53H1221.28L1227.79 21.5Z",
    fill: "#F3F4F5"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M1305.92 21.5L1312.43 41.53H1333.5L1316.45 53.92L1322.96 73.95L1305.92 61.57L1288.88 73.95L1295.39 53.92L1278.35 41.53H1299.41L1305.92 21.5Z",
    fill: "#F3F4F5"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M1384.05 21.5L1390.56 41.53H1411.62L1394.58 53.92L1401.09 73.95L1384.05 61.57L1367.01 73.95L1373.52 53.92L1356.47 41.53H1377.54L1384.05 21.5Z",
    fill: "#F3F4F5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterflagbg);
export default __webpack_public_path__ + "static/media/footerflagbg.d4f400ffe89bf441ddec429a1601102e.svg";
export { ForwardRef as ReactComponent };